import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import styles from './styles';

import '@fontsource/poppins/300.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';

const GlobalStyles = createGlobalStyle`
  *, *:before, *:after {
    box-sizing: inherit;
  }

  .hidden {
    display:none;
  }

  form label {
    color: #333133;
  }

  .hint {
    color: #494a4c;
  }

 ${'' /* overwrite bazaarvoice product review image overlay styles */}
  .bv-mbox .bv-mbox-close {
    height: 3.75rem !important;
    width: 3.125rem !important;
    span {
      color: ${styles.colors.gray[400]} !important;
      font-size: 2.5rem !important;
    }
  }
   .bv-media-viewer-ribbon .bv-media-viewer-ribbon-summary  {
    color: white !important;
  }
`;

// styles for SSO site
const LegacyStyles = createGlobalStyle`
  ${normalize}

  body {
    font-family: 'Poppins', sans-serif;
  }
`;

export { LegacyStyles, GlobalStyles };
